export const environment = {
  production: true,
  sentry: true,
  backend: 'https://api.tyllt.feelity.dev',
  link: 'https://app.tyllt.feelity.dev/',
  version: 'v1',
  money: 'https://preprod-cb.w-ha.com/secure-node-resources/js/secure-cb.min.js',
  redirectUri: 'urn:ietf:wg:oauth:2.0:oob',
};
